import { render, staticRenderFns } from "./CustomSido.vue?vue&type=template&id=70d9c216&scoped=true"
import script from "./CustomSido.vue?vue&type=script&lang=js"
export * from "./CustomSido.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "70d9c216",
  null
  
)

export default component.exports